import React, { Component, Fragment } from "react";
import "./Site.css";
import {
  Card,
  CardHeader,
  CardBody,
  Button,
  Table,
  Badge,
  Collapse
} from "reactstrap";
import moment from "moment";
import _ from "lodash";
import './Site.css';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { api, dateHelper, constant, uiHelper, filterHelper} from "../helpers";
import { Pager } from "../components";
import "react-datepicker/dist/react-datepicker.css";
import { Link } from "react-router-dom";
import { Schedule } from "../components";

export default class MaintenanceDetails extends Component {
  static displayName = MaintenanceDetails.name;
  constructor(props) {
    super(props);
    this.state = {
      message: null,
      messageColor: null,
      isMessageVisible: false,
      recordsCollapse: false,
      filters: [{
        filterName: "EquipmentId",
        value: props.equipmentId ? props.equipmentId : null,
        filteredDisplay: "Equipment Id"
      }],
      pagedList: null,
      sortColumn: props.maintenanceTypeId === constant.maintenanceType.Maintenance.id
        ? "MaintenanceDate"
        : "CalibrationDate",
      sortAscending: false,

    };
    this.refreshList = this.refreshList.bind(this);
    this.setPage = this.setPage.bind(this);
  }

  componentDidMount() {
    this.refreshList();
  }

  refreshList(sortColumn, sortAscending, filters, pageNumber) {
    const resolvedFilters = filters || this.state.filters;
    const resolvedSort = {
      sortColumn: sortColumn || this.state.sortColumn,
      sortAscending: sortAscending || this.state.sortAscending
    };
    const payload = {
      activeOnly: null,
      name: null,
      ...resolvedSort,
      ...filterHelper.filtersToObject(resolvedFilters),
      pageSize: 5,
      page: pageNumber || (this.state.pagedList ? this.state.pagedList.pageNumber : 1)
    };

    const url = this.props.maintenanceTypeId === constant.maintenanceType.Maintenance.id
      ? "Equipment/MaintenanceRecords"
      : "Equipment/CalibrationRecords";

    api.post(url, payload)
      .then(response => {
        if (response.data) {
          let plist = _.map(response.data.dataSource, x => {
            x.collapse = false;
            return x;
          });
          this.setState({
            ...resolvedSort,
            pagedList: {
              list: plist,
              pageNumber: response.data.page,
              pageSize: response.data.pageSize,
              totalItems: response.data.totalItems,
              totalPages: response.data.totalPages
            },
            filters: resolvedFilters,
          });
        }
      })
  }

  setPage(page) {
    this.refreshList(null, null, null, page);
  }

  toggleCollapse() {
    this.setState({
      recordsCollapse: !this.state.recordsCollapse
    })
  }

  render() {
    const {
      pagedList
    } = this.state;
    return (
      <Card className="p-2 mb-2">
        <CardHeader className="boldText">
          <span className="mr-2"><FontAwesomeIcon icon={this.props.title === constant.maintenanceType.Calibration.name ? "cogs" : "tools"}  title={`${this.props.title} History`} /></span>
          {this.props.title} Records
            <Button size="sm" className="float-right cbdmdSuccess" onClick={() => this.toggleCollapse()}>{this.state.recordsCollapse ? "View Less" : "View More"}</Button>
        </CardHeader>
        <Collapse isOpen={this.state.recordsCollapse}>
        <CardBody>
            {pagedList && pagedList.list && pagedList.list.length > 0 ? ( 
              <Fragment>
                  <Schedule
                    scheduledMaintenance={this.props.nextScheduledMaintenance}
                    deleteScheduledWork={this.props.deleteScheduledWork}
                    onDateChange={this.props.onDateChange}
                    nextScheduledDate={this.props.nextScheduledDate}
                    title={this.props.title}
                    maintenanceTypeId={this.props.maintenanceTypeId}
                  />
            <Table>
              <thead>
                <tr>
                  <th style={{ width: "124px" }}>Date</th>
                  <th>Results</th>
                </tr>
              </thead>
              <tbody>
              {pagedList.list.map((record, idx) => (
                  this.props.title === constant.maintenanceType.Calibration.name ? (
                  <tr key={`recM-${idx}${record.id}`}>
                      <td><Link to={`/calibration_record/${record.id}`}>{moment(record.calibrationDate).format("M/DD/YYYY")}</Link></td>
                    <td>
                      {record.calibrationResult}
                      {(record.beginningCalibrationRange !== null) &&
                        <div>
                          <span className="boldText">Beginning Calibration:</span>
                          <span className="ml-2">{record.beginningCalibrationRange || "N/A"}</span>
                          <span className="boldText ml-2">Ending Calibration:</span>
                          <span className="ml-2">{record.endingCalibrationRange || "N/A"}</span>
                        </div>
                      }

                      {(record.foundCalibrationValue !== '' && record.foundCalibrationValue !== null) &&
                        <div>
                          <span className="boldText">Found Calibration Value:</span>
                          <span className="ml-2">{record.foundCalibrationValue}</span>
                        </div>
                      }
                      {(record.scheduledMaintenance !== null) &&
                        <div>
                          <span className="boldText">Next Scheduled Maintenance:</span>
                          <span className="ml-2">{dateHelper.formatStringDate(record.scheduledMaintenance.date)}</span>
                        </div>
                      }
                      {(record.vendorMechanicName !== null) &&
                        <div>
                          <span className="boldText">Completed By:</span>
                          <span className="ml-2">{record.vendorMechanicName}</span>
                        </div>
                      }
                        <div>
                          <span className="boldText">Passed:</span>
                          <span className="ml-2">
                            <Badge color={uiHelper.resolveCalibrationResults(record.passed)}>{record.passed ? "Yes" : "No"}
                              <FontAwesomeIcon className="ml-2" color={record.passed ? "success" : "danger"} icon={record.passed ? "thumbs-up" : "thumbs-down"} />
                            </Badge>
                          </span>
                        </div>
                    </td>
                    </tr>
                  ) : (
                      <tr key={`recM-${idx}${record.id}`}>
                        <td><Link to={`/maintenance_record/${record.id}`}>{moment(record.maintenanceDate).format("M/DD/YYYY")}</Link></td>
                        <td>
                          {record.summaryOfMaintenance}
                          <div>
                            <span className="boldText">Recommendation:</span>
                            <span className="ml-2">{record.recommendations || "N/A"}</span>
                          </div>
                          {(record.scheduledMaintenance !== null) &&
                            <div>
                              <span className="boldText">Next Scheduled Maintenance:</span>
                              <span className="ml-2">{dateHelper.formatStringDate(record.scheduledMaintenance.date)}</span>
                            </div>
                          }
                          {(record.vendorMechanicName !== null) &&
                            <div>
                              <span className="boldText">Completed By:</span>
                              <span className="ml-2">{record.vendorMechanicName}</span>
                            </div>
                          }
                        </td>
                      </tr>
                  )
                ))}
              </tbody>
                </Table>
                <Pager {...pagedList} callBack={this.setPage} />

            </Fragment>
          ) : (
              <div className="detailText">No {this.props.title} Records Found</div>
            )}

          </CardBody>
        </Collapse>
      </Card>

    );
  }
}


// WEBPACK FOOTER //
// ./src/components/MaintenanceDetails.js